/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_PlaceholderInputs */

const en_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const fr_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen`)
};

const it_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const ru_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания`)
};

const es_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const zh_cn2_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const ja_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注記`)
};

const hi_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स`)
};

const pt_pt2_notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_placeholder = /** @type {((inputs?: Notes_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_placeholder(inputs)
	if (locale === "de") return de_notes_placeholder(inputs)
	if (locale === "it") return it_notes_placeholder(inputs)
	if (locale === "ru") return ru_notes_placeholder(inputs)
	if (locale === "es") return es_notes_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_placeholder(inputs)
	if (locale === "ja") return ja_notes_placeholder(inputs)
	if (locale === "hi") return hi_notes_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_placeholder(inputs)
	return en_notes_placeholder(inputs)
});